import React, { useState } from 'react';
import Truncate from 'react-truncate';
import moment from 'moment';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import ApplicationsIcon from 'assets/ApplicationsIcon';
import {
  AppliedAreaCell,
  ProductsCell,
  RecordTypeIconCell,
  ViewMoreCell
} from 'components/LinkedRecordCells';
import { LinkedRecord } from 'screens/Applications&WorkOrders/WorkOrders/Hooks/linkedRecords.types';
import { DATE_TIME_FORMAT, LINKED_RECORD_NAME_LIST_CAP } from './types';

const TOOLTIP_OVERLAY_STYLE = { backgroundColor: '#232630' };

const RecordNameCell = ({ record }: { record: LinkedRecord }) => {
  const [isTruncated, setIsTruncated] = useState(false);

  return (
    <div className="flex flex-col min-w-0">
      <Tooltip
        title={isTruncated ? record.name : ''}
        placement="top"
        overlayInnerStyle={TOOLTIP_OVERLAY_STYLE}
      >
        <Truncate lines={1} ellipsis="…" onTruncate={setIsTruncated}>
          {record.name}
        </Truncate>
      </Tooltip>
      <span className="text-xs text-neutral-50">
        {moment(record.startDate).format(DATE_TIME_FORMAT)}
      </span>
    </div>
  );
};

/**
 * Only the icon and View More cells are fixed; the rest share what's left. With
 * no `scroll.x` the table never scrolls, so View More is always visible.
 */
const getLinkedRecordsColumns = (
  onViewMore: (recordId: string) => void
): Array<any> => [
  {
    title: '',
    dataIndex: 'recordType',
    key: 'recordType',
    width: 60,
    render: (_: any, record: LinkedRecord) => (
      <RecordTypeIconCell
        icon={<ApplicationsIcon className="w-6 h-6" />}
        title="Application"
        testId={`record-type-icon-${record.id}`}
      />
    )
  },
  {
    title: 'Record Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    render: (_: any, record: LinkedRecord) => <RecordNameCell record={record} />
  },
  {
    title: 'Applied Area',
    dataIndex: 'fieldsBrief',
    key: 'appliedArea',
    ellipsis: true,
    render: (_: any, record: LinkedRecord) => (
      <AppliedAreaCell record={record} maxItems={LINKED_RECORD_NAME_LIST_CAP} />
    )
  },
  {
    title: 'Products',
    dataIndex: 'productsBrief',
    key: 'products',
    ellipsis: true,
    render: (_: any, record: LinkedRecord) => (
      <ProductsCell record={record} maxItems={LINKED_RECORD_NAME_LIST_CAP} />
    )
  },
  {
    title: '',
    dataIndex: 'viewMore',
    key: 'viewMore',
    width: 133,
    render: (_: any, record: LinkedRecord) => (
      <ViewMoreCell
        onClick={() => onViewMore(record.id)}
        testId={`view-more-${record.id}`}
      />
    )
  }
];

export default getLinkedRecordsColumns;
